export const ApiRoutes = {
  // Auth
  login: "auth/login",
  forgotPassword: "auth/forgot-password",
  linkExpired: "auth/link-expired",
  resetPassword: "auth/reset-password",

  // Profile
  profile: "profile",
  updateProfile: "profile/update",
  changePassword: "change-password",

  // Dashboard
  dashboard: "dashboard/counts",

  //Role
  getRole: "role",
  addRole: "role",

  //Customer
  addCustomer: "customer",

  // Staff
  staff: 'staff',

  // Chef
  chef: 'chef',
  deletChef: 'chef/delete-chef',
  chefPersonalDetails: 'chef/personal-details',
  chefProfessionalDetails: 'chef/professional-details',
  chefAddressDetails: 'chef/address-details',
  chefRatesDetails: 'chef/rates-details',
  chefAreaDetails: 'chef/area-details',
  chefGeneralAvailability: 'chef/general-availability',
  getChefStatus:"chef/status",
  getChefVerified:"chef/verify",
  addChefImage:"chef/upload-images",
  addChefAreaDetails:"chef/area-details",
  addChefAddressDetails:"chef/address-details",
  addChefRatesDetails:"chef/rates-details",
  getChefRates:"dish-config",
  getCuisineList:"cuisine/list",
  //Cuisine
  addCuisine: "cuisine",

  //Dishes
  addDishes: "dish",

  // Master
  masterCuisines: 'master/get-cuisines',
  masterLanguages: 'master/get-language',
  masterSlot: 'master/get-slot',

  //Coupons 
  getCoupons: "coupon",
  addCoupons: "coupon",

  // Config
  config: "config",
  notification: "notification",
  getnotification: "notification/notification-details",
  cms: "cms",

  // Dish Config
  dishConfig: "dish-config",

  // Booking
  cloneBooking: "booking/clone-order",
  cloneBook: "booking/clone-order",
};
